/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Export_SegmentInputs */

const en_ui_studio_export_segment = /** @type {(inputs: Ui_Studio_Export_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export this segment`)
};

const de_ui_studio_export_segment = /** @type {(inputs: Ui_Studio_Export_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Abschnitt exportieren`)
};

/**
* | output |
* | --- |
* | "Export this segment" |
*
* @param {Ui_Studio_Export_SegmentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_export_segment = /** @type {((inputs?: Ui_Studio_Export_SegmentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Export_SegmentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_export_segment(inputs)
	return de_ui_studio_export_segment(inputs)
});